export const MAIN_PAGE_TRACKING_EVENTS = {
  feature: "Companion",
  source: "Companion Main Page",
  viewCompanionDashboard: "Viewed Companion Dashboard Main Page",
}

export const AUTH_PAGE_TRACKING_EVENTS = {
  feature: "Companion",
  source: "Companion Auth Page",
  viewAuthPage: "Viewed Companion Auth Page",
}

export const LOGIN_PAGE_TRACKING_EVENTS = {
  feature: "Companion",
  source: "Companion Login Page",
  viewLoginPage: "Viewed Companion Login Page",
}

export const TRACKING_EVENT_METADATA = {
  source: "Companion",
  product: "Scaler Ai",
}

export const DSA_MOCK_TRACKING_EVENTS = {
  feature: "DSA Mock Interview",
  viewStartInterviewPage: "View Start Interview Page",
  viewInterviewSetupPage: "View Interview Setup Page",
  clickStartInterview: "Click Start Interview",
  viewInterviewPage: "View Interview Page",
  clickSendMessage: "Click Send Message",
  viewFeedbackPage: "View Feedback Page",
}

export const LANGUAGE_MOCK_TRACKING_EVENTS = {
  feature: "Behavioural Mock Interview",
  viewInterviewPage: "View Interview Page",
  viewStartInterviewPage: "View Start Interview Page",
  clickStartInterview: "Click Start Interview",
  clickContinueSession: "Click Continue Session",
  clickRestartSession: "Click Restart Session",
  viewFeedbackPage: "View Feedback Page",
}

export const LLD_MOCK_TRACKING_EVENTS = {
  feature: "LLD Mock Interview",
  viewStartInterviewPage: "View Start Interview Page",
  viewInterviewPage: "View Interview Page",
  clickStartInterview: "Click Start Interview",
  resumeExistingInterview: "Resume Existing Interview",
  clickSendMessage: "Click Send Message",
  viewFeedbackPage: "View Feedback Page",
}

export const HLD_MOCK_TRACKING_EVENTS = {
  feature: "HLD Mock Interview",
  viewStartInterviewPage: "View Start Interview Page",
  viewInterviewPage: "View Interview Page",
  clickStartInterview: "Click Start Interview",
  resumeExistingInterview: "Resume Existing Interview",
  clickSendMessage: "Click Send Message",
  viewFeedbackPage: "View Feedback Page",
}

export const SESSION_TRACKING = {
  clickMicButton: "Click Microphone",
  clickToggleCamera: "Click Toggle Camera",
  enableCamera: "Enable Camera",
  proctoringViolation: "Proctoring Violation",
}

export const ERROR_TRACKING = {
  fetchApiError: "Fetch API Error",
}

export const MOCK_TRACKINGS = {
  source: "Companion Mock Interview",
  feature: "Mock Interview",
  product: "Scaler Ai",
  textHelpRequestButtonClicked: "Text Help Request Button Clicked",
  videoHelpRequestButtonClicked: "Video Help Request Button Clicked",
  chatBotSource: "chat_box",
  menuOptionSource: "menu_options",
}

export const CALLME_PAGE_TRACKING_EVENTS = {
  call_me_clicked: "Call Me Clicked",
  place_another_call_clicked: "Place Another Call Clicked",
}

export const SUPPORT_TRACKING_EVENTS = {
  submit_webform_ticket: "Submit Webform Ticket",
}

export const COMPANION_TRACKING_EVENTS = {
  // Features
  product: "ScalerAI",
  feature: "Companion",

  // Interview Experience Tracking
  interviewExperienceSource: "Interview Experiences Page",
  interviewExperienceFeature: "Interview Experiences",
  viewInterviewExperiencesPage: "View Interview Experiences Page",
  interviewExperienceHandleCompanySearch: "Handle Company Search",
  interviewExperienceHandleRoleSearch: "Handle Role Search",
  interviewExperienceHandleSearch: "Handle Search Button Click",

  // Meetings (FlashCard/ Notes)
  meetingSource: "Companion Meeting Page",
  viewMeetingPage: "View Meeting Page",
  viewMeetingFlashcardPage: "View Meeting Flashcard Page",
  viewMeetingFlashcardPageFailed: "View Meeting Flashcard Page Failed",
  viewMeetingPairmasterPage: "View Meeting Pairmaster Page",
  viewMeetingNotesPage: "View Meeting Notes Page",
  viewMeetingFlashCardPage: "View Meeting Flashcard Page",

  // Interview Page Tracking
  interviewSource: "Companion Mock Interview Page",
  viewInterviewPage: "View Interview Page",
  viewUnauthorizedInterviewPage: "View Unauthorized Interview Page",
  viewInterviewSomethingExcitingPage: "View Something Exciting Page",
  viewInterviewJudgePage: "View Interview Judge Page",
  viewInterviewAdminFeedbackPage: "View Interview Admin Feedback Page",
  viewWaitingLobby: "View Waiting Lobby",
  viewJoinRoom: "View Join Room",
  onboardingLinksClicked: "Onboarding Links Clicked",
  knowMoreButtonClicked: "Know More Button Clicked",
  modalCloseButtonClicked: "Modal Close Button Clicked",
  noButtonClicked: "No Button Clicked",
  typeformSubmissionDone: "Typeform Submission Done",
  yesButtonClicked: "Yes Button Clicked",
  sessionInitializationFailure: "Session Initialization Failure",
  groqAudioTranscriptionStarted: "Groq Audio Transcription Started",
  groqAudioTranscriptionSuccess: "Groq Audio Transcription Success",
  groqAudioTranscriptionFailed: "Groq Audio Transcription Failed",
  groqAudioRecordingStarted: "Groq Audio Recording Started",
  groqAudioRecordingStopped: "Groq Audio Recording Stopped",
  groqAudioRecordingUploadError: "Groq Audio Recording Upload Error",
  codeLanguageSelectClicked: "Code Language Select Clicked",
  endInterviewButtonClicked: "End Interview Button Clicked",
  endInterviewModalCloseButtonClicked: "End Interview Modal Close Button Clicked",
  endInterviewButtonConfirmationClickedFailed: "End Interview Button Confirmation Clicked Failed",
  endInterviewButtonConfirmationClicked: "End Interview Button Confirmation Clicked",
  checkNetworkSpeedModalButtonClicked: "Check Network Speed Modal Button Clicked",
  checkNetworkSpeedModalCloseClicked: "Check Network Speed Modal Close Clicked",
  settingsModalInputChangeSelectClicked: "Settings Modal Input Change Select Clicked",
  websocketCloseConnectionTriggered: "Websocket Close Connection Triggered",
  websocketCloseConnectionTriggeredError: "Websocket Close Connection Triggered Error",
  websocketPingPongInitializeError: "Websocket Ping Pong Initialize Error",
  websocketFinalResponseChunkReceived: "Websocket Final Response Chunk Received",
  websocketEndChunkReceived: "Websocket End Chunk Received",
  websocketInitialized: "Websocket Initialized",
  websocketSendMessageFailed: "Websocket Send Message Failed",
  websocketSendMessageSuccess: "Websocket Send Message Success",

  // Landing Page Tracking
  landingSource: "Companion Upcoming Page",
  viewLandingPage: "View Upcoming Page",
  landingNotifyMeButtonClicked: "Notify Me Button Clicked",

  // Admin Page Tracking
  adminSource: "Companion Admin Page",
  viewAdminPage: "View Admin Page",
  addProblemButtonClicked: "Add Problem Button Clicked",
  addProblemButtonClickedFailed: "Add Problem Button Clicked Failed",
  editProblemButtonClicked: "Edit Problem Button Clicked",
  editProblemButtonClickedFailed: "Edit Problem Button Clicked Failed",
  addProblemTagButtonClicked: "Add Problem Button Clicked",
  addProblemTagButtonClickedFailed: "Add Problem Button Clicked Failed",
  addTestProblemButtonClicked: "Add Test Problem Button Clicked",
  addTestProblemButtonClickedFailed: "Add Test Problem Button Clicked Failed",
  deleteTestProblemButtonClicked: "Delete Test Problem Button Clicked",
  deleteTestProblemButtonClickedFailed: "Delete Test Problem Button Clicked Failed",
  addLanguageProblemButtonClicked: "Add Language Problem Button Clicked",
  addLanguageProblemButtonClickedFailed: "Add Language Problem Button Clicked Failed",
  addProblemSolutionButtonClicked: "Add Problem Solution Button Clicked",
  addProblemSolutionButtonClickedFailed: "Add Problem Solution Button Clicked Failed",
  addProblemHintButtonClicked: "Add Problem Hint Button Clicked",
  addProblemHintButtonClickedFailed: "Add Problem Hint Button Clicked Failed",
  editTestMetaButtonClicked: "Edit Test Meta Button Clicked",
  editTestMetaButtonClickedFailed: "Edit Test Meta Button Clicked Failed",
  createTestButtonClicked: "Create Test Button Clicked",
  createTestButtonClickedFailed: "Create Test Button Clicked Failed",
  addInterviewExperienceButtonClicked: "Add Interview Experience Button Clicked",
  addInterviewExperienceButtonClickedFailed: "Add Interview Experience Button Clicked Failed",

  // Feedback Page Tracking
  feedbackSource: "Companion Feedback Page",
  viewFeedbackPage: "View Feedback Page",
  downloadFeedbackReportClicked: "Download Feedback Report Clicked",

  // Auth Page Tracking
  authSource: "Companion Auth Page",
  viewAuthPage: "View Auth Page",
  logoutButtonClicked: "Logout Button Clicked",

  // Course Page Tracking
  courseSource: "Companion Course Page",
  viewCoursePage: "View Course Page",
  viewCourseTaskPage: "View Course Task Page",
  viewCourseMyCoursesPage: "View Course My Courses Page",
  viewCourseHomePage: "View Course Home Page",
  viewCourseTopicsPage: "View Course Topics Page",
  viewCourseNextTopicPage: "View Course Next Topic Page",
  viewExerciseCategoryPage: "View Exercise Category Page",
  viewCourseSessionIDPage: "View Course Session ID Page",
  viewCourseFeedbackPage: "View Course Feedback Page",
  logExerciseCategoryNoExercisesFound: "No Exercises Found",
  logCourseNoCourseFound: "No Courses Found",
  logCourseFeedbackNotPresent: "Course Feedback Not Present",
  courseFeedbackHomeClicked: "Course Feedback Home Clicked",
  courseFeedbackRetryClicked: "Course Feedback Retry Clicked",
  courseFeedbackContinueClicked: "Course Feedback Continue Clicked",

  // System Check Page Tracking
  systemCheckSource: "Companion System Check Page",
  viewSystemCheckPage: "View System Check Page",
  retryButtonClicked: "Retry Button Clicked",
  enterFullScreenButtonClicked: "Enter Fullscreen Button Clicked",
  redirectButtonClicked: "Redirect Button Clicked",
  continueButtonClicked: "Continue Button Clicked",
  browserCheckSuccess: "Browser Check Success",
  browserCheckFailure: "Browser Check Failure",
  networkCheckSuccess: "Network Check Success",
  networkCheckFailure: "Network Check Failure",
  systemSetupCheckSuccess: "System Setup Check Success",
  systemSetupCheckFailure: "System Setup Check Failure",
  systemSetupSectionCheckSuccess: "System Setup Section Check Success",
  systemSetupSectionCheckFailure: "System Setup Section Check Failure",
  systemSetupMediaDeviceChanged: "System Setup Media Device Changed",
  recordingButtonClicked: "Recording Button Clicked",
  playAudioButtonClicked: "Play Audio Button Clicked",
  screenRecordingSuccess: "Screen Recording Success",
  screenRecordingFailure: "Screen Recording Failure",
  screenRecordingStop: "Screen Recording Stop",
  microphoneAccessFailure: "Microphone Access Failure",
  cameraAccessFailure: "Camera Access Failure",
  speakerAccessFailure: "Speaker Access Failure",

  // Enterprise Page Tracking
  enterpriseSource: "Companion Enterprise Page",
  viewEnterprisePage: "View Enterprise Page",
  viewEnterpriseTeamsPage: "View Enterprise Teams Page",
  viewEnterpriseTeamIDPage: "View Enterprise Team ID Page",
  viewEnterpriseReportPage: "View Enterprise Report Page",
  viewEnterpriseInterviewIDPage: "View Enterprise Interview ID Page",
  viewEnterpriseMembersPage: "View Enterprise Members Page",
  viewEnterpriseMembersPageFailed: "View Enterprise Members Page Failed",
  viewEnterpriseInterviewTemplatePage: "View Enterprise Interview Template Page",
  viewEnterpriseInterviewTemplatePageFailed: "View Enterprise Interview Template Page Failed",
  viewEnterpriseInterviewTemplateCreatePage: "View Enterprise Interview Template Create Page",
  viewEnterpriseInterviewTemplateCreatePageFailed: "View Enterprise Interview Template Create Page Failed",
  viewEnterpriseAuthPage: "View Enterprise Auth Page",
  viewEnterpriseSignInPage: "View Enterprise Sign In Page",
  viewEnterpriseSignUpPage: "View Enterprise Sign Up Page",
  enterpriseSignUpPageSuccess: "Enterprise Sign Up Page Success",
  enterpriseForgetPasswordPageSuccess: "Enterprise Forget Password Page Success",
  enterpriseResetPasswordPageSuccess: "Enterprise Reset Password Page Success",

  // Interview Session Timing Events
  interviewSessionStart: "Interview Session Start",
  interviewSessionEnd: "Interview Session End",

  // Miscellaneous tracking events
}
